import React, { useState, useEffect } from "react";
import { Link, useNavigate, useNavigation } from "react-router";

import { LogoImg } from "../../Constants/Images";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import SignupForm from "./SignupForm";

const SignPage: React.FC = () => {
  return (
    <div className="auth-page-wrapper">
      <div className="auth-page-header">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-sm-6">
              <Link to="/">
                <img src={LogoImg} alt="" className="logo-img" />
              </Link>
            </div>

            <div className="col-md-6 col-sm-6">
              <div className="header-auth-links">
                <ul>
                  <li>
                    <FontAwesomeIcon
                      icon={faGlobe}
                      size="lg"
                      color="#000000"
                      style={{ marginRight: 5 }}
                    />{" "}
                  </li>

                  <li>
                    <Link to="/login" className="sign-up">
                      Login
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <SignupForm />
      </div>

      <div className="auth-footer-wrapper">
        <div className="container">
          <ul>
            <li>&copy; 2025 spacii</li>
            <li>
              <Link to="#">Terms of Service</Link>
            </li>
            <li>
              <Link to="#">Privacy Policy</Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SignPage;
